import { ToolingDescriptionStepComponent } from './description-step/description-step.component';
import { ToolingDocumentsStepComponent } from './documents-step/documents-step.component';
import { ToolingStepComponent } from './tooling-step/tooling-step.component';
import { ToolingSchedulingStepComponent } from './scheduling-step/scheduling-step.component';

export const toolingStepsComponents = [
  ToolingDescriptionStepComponent,
  ToolingDocumentsStepComponent,
  ToolingStepComponent,
  ToolingSchedulingStepComponent,
];
